"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSuggestionsQuery = useSuggestionsQuery;
var _fetching = require("@ori/fetching");
var _logger = require("@ori/logger");
var _react = require("react");
var _constants = require("../constants");
var _swrConfig = require("../constants/swrConfig");
var _hooks = require("../hooks");
var _logger2 = require("../logger");
var _utils = require("../utils");
const fetchData = async options => (0, _utils.getUrl)(options);
function useSuggestionsQuery({
  filter,
  onSuggestionsLoadSuccess,
  page,
  prioritizedAddressId
}) {
  const logger = (0, _logger.useLogger)('useSuggestionsQuery');
  const [isLoadMoreVisible, setIsLoadMoreVisible] = (0, _react.useState)(false);
  const skip = page * _constants.SUGGESTIONS_PAGE_SIZE;
  const top = _constants.SUGGESTIONS_PAGE_SIZE + 1;
  const usedParams = {
    filter,
    prioritizedAddressId,
    skip,
    top
  };
  const {
    cacheKeys,
    urlOptions
  } = (0, _hooks.useUrlOptions)('/system/ajax/DeliverySelection/GetSuggestions', usedParams);
  const fetcher = async () => fetchData(urlOptions);
  const {
    onError: onErrorBase,
    ...otherOptions
  } = _swrConfig.errorHandlingSwrOptions;

  // Should be loading conditionally only when filter is set.
  // Returned suggestions array is always set, but might be empty.
  const isActive = Boolean(filter);
  const {
    data: suggestions = [],
    error: suggestionsError,
    isValidating: isSuggestionsLoading
  } = (0, _fetching.useSWR)(isActive ? cacheKeys : null, fetcher, {
    ...otherOptions,
    onSuccess: result => {
      (0, _logger2.logInfo)(`useSuggestionsQuery() hook finished successfully. Loaded suggestions data for page ${page}:\n\t`, result);
      setIsLoadMoreVisible(result.length > _constants.SUGGESTIONS_PAGE_SIZE);
      onSuggestionsLoadSuccess?.(result, page);
    },
    onError: error => {
      logger.error(error);
      onErrorBase(error);
    }
  });
  return {
    isLoadMoreVisible,
    isSuggestionsLoading,
    suggestions,
    suggestionsError
  };
}